import {
  StoryCard,
  StoryCardContentText,
  StoryCardContentTitle,
  StoryCardPollContent,
  StoryCardQuoteContent,
  StoryCardType,
} from '../../services';

export const getStoryCardTitle = (card: StoryCard) => {
  const { type, content, event } = card;

  switch (type) {
    case StoryCardType.EDITORIAL:
    case StoryCardType.IMAGE:
    case StoryCardType.AUDIO:
    case StoryCardType.VIDEO:
    case StoryCardType.PDF:
      return (content as StoryCardContentText).headline;
    case StoryCardType.ARTICLE:
    case StoryCardType.POST:
    case StoryCardType.THREAD:
      return (content as StoryCardContentTitle).title;
    case StoryCardType.QUOTE:
      return (content as StoryCardQuoteContent).quote;
    case StoryCardType.POLL:
      return (content as StoryCardPollContent).headline;
    case StoryCardType.EVENT:
      return event?.name ?? '';
    default:
      return '';
  }
};
